import styled, { css } from 'styled-components';
import { Input, ThemeProp } from '@kite-js/core';

export const SearchBarInput = styled(Input)<Required<ThemeProp>>`
    ${(props: Required<ThemeProp>) => css`
        border-radius: ${props.theme.spacing.XL};
        padding-left: ${props.theme.spacing.L};
        padding-right: ${props.theme.spacing.L};

        &[readonly] {
            color: ${props.theme.palette.text[800]};
        }

        &:focus {
            outline: auto ${props.theme.palette.primary.solid.background};
        }

        html[dir='ltr'] & {
            + svg {
                right: ${props.theme.spacing.M};
                padding: ${props.theme.spacing.XS};
            }
        }

        html[dir='rtl'] & {
            + svg {
                left: ${props.theme.spacing.M};
                padding: ${props.theme.spacing.XS};
            }
        }
    `}
`;
